$(document).ready(function() {

    const bannerTemplates = {
        "apm-cta-banner":
            '<div class="blog-review-wrapper bg-apm-gradient">' +
                '<div class="row">' +
                    '<div class="col-lg-6 col-md-6">' +
                        '<h3>Boost Your App Performance Instantly!</h3>' +
                        '<p>Utilize end-to-end tracing for precise issue resolution and optimized resource usage, ensuring exceptional user experiences through efficient request handling and latency reduction.</p>' +
                        '<a href="https://www.atatus.com/signup?utm_source=blog&utm_medium=side_banner" class="button-banner button-dark-green-bg margin-right-10">Sign up for free</a>' +
                        '<a href="https://www.atatus.com/request-demo?utm_source=blog&utm_medium=center_banner&utm_content=apm" class="button-banner button-dark-green-outline">Book a Demo</a>' +
                    '</div>' +
                    '<div class="col-lg-6 col-md-6 banner-img">' +
                        '<img src="/blog/assets/images/atatus-transparent-logo.svg" class="banner-logo" alt="atatus-logo" />' +
                        '<img src="/blog/assets/images/application-monitoring.webp" class="product-img" alt="apm" />' +
                    '</div>' +
                '</div>' +
            '</div>',
        "infra-cta-banner":
            '<div class="blog-review-wrapper bg-infra-gradient">' +
                '<div class="row">' +
                    '<div class="col-lg-6 col-md-6">' +
                        '<h3>Discover Infrastructure Issues Before They Impact!</h3>' +
                        '<p>Simplify cloud environment monitoring with our SaaS-based solution. Gain comprehensive metrics, visualizations, and alerts for optimized security and performance.</p>' +
                        '<a href="https://www.atatus.com/signup?utm_source=blog&utm_medium=side_banner" class="button-banner button-violet-bg margin-right-10">Sign up for free</a>' +
                        '<a href="https://www.atatus.com/request-demo?utm_source=blog&utm_medium=center_banner&utm_content=infra" class="button-banner button-violet-outline">Book a Demo</a>' +
                    '</div>' +
                    '<div class="col-lg-6 col-md-6 banner-img">' +
                        '<img src="/blog/assets/images/atatus-transparent-logo.svg" class="banner-logo" alt="atatus-logo" />' +
                        '<img src="/blog/assets/images/infrastructure-monitoring.webp" class="product-img" alt="infra" />' +
                    '</div>' +
                '</div>' +
            '</div>',
        "kubernetes-cta-banner":
            '<div class="blog-review-wrapper bg-kubernetes-gradient">' +
                '<div class="row">' +
                    '<div class="col-lg-6 col-md-6">' +
                        '<h3>Safeguard Your Kubernetes Environment</h3>' +
                        '<p>Effortlessly monitor Pods, Nodes, and Containers in one place. Monitor uptime, resource utilization, and cluster interactions efficiently for optimized containerized applications.</p>' +
                        '<a href="https://www.atatus.com/signup?utm_source=blog&utm_medium=side_banner" class="button-banner button-sea-green-bg margin-right-10">Sign up for free</a>' +
                        '<a href="https://www.atatus.com/request-demo?utm_source=blog&utm_medium=center_banner&utm_content=kubernetes" class="button-banner button-sea-green-outline">Book a Demo</a>' +
                    '</div>' +
                    '<div class="col-lg-6 col-md-6 banner-img">' +
                        '<img src="/blog/assets/images/atatus-transparent-logo.svg" class="banner-logo" alt="atatus-logo" />' +
                        '<img src="/blog/assets/images/kubernetes-monitoring.webp" class="product-img" alt="kubernetes" />' +
                    '</div>' +
                '</div>' +
            '</div>',
        "logs-cta-banner":
            '<div class="blog-review-wrapper bg-logs-gradient">' +
                '<div class="row">' +
                    '<div class="col-lg-6 col-md-6">' +
                        '<h3>Centralize Your Logs with Ease and Precision</h3>' +
                        '<p>Integrate and analyze logs, metrics, and traces in one unified view. Simplify troubleshooting and enhance performance with scalable, cost-effective log management.</p>' +
                        '<a href="https://www.atatus.com/signup?utm_source=blog&utm_medium=side_banner" class="button-banner button-greeny-blue-bg margin-right-10">Sign up for free</a>' +
                        '<a href="https://www.atatus.com/request-demo?utm_source=blog&utm_medium=center_banner&utm_content=logs" class="button-banner button-greeny-blue-outline">Book a Demo</a>' +
                    '</div>' +
                    '<div class="col-lg-6 col-md-6 banner-img">' +
                        '<img src="/blog/assets/images/atatus-transparent-logo.svg" class="banner-logo" alt="atatus-logo" />' +
                        '<img src="/blog/assets/images/logs-monitoring.webp" class="product-img" alt="logs" />' +
                    '</div>' +
                '</div>' +
            '</div>',
        "observability-cta-banner":
            '<div class="blog-review-wrapper bg-observability-gradient">' +
                '<div class="row">' +
                    '<div class="col-lg-6 col-md-6">' +
                        '<h3>Gain Complete Visibility Across Your Stack</h3>' +
                        '<p>Seamlessly switch between metrics, traces, and logs to pinpoint issues quickly. Accelerate issue resolution, optimize costs, and prevent downtime effortlessly.</p>' +
                        '<a href="https://www.atatus.com/signup?utm_source=blog&utm_medium=side_banner" class="button-banner button-brown-bg margin-right-10">Sign up for free</a>' +
                        '<a href="https://www.atatus.com/request-demo?utm_source=blog&utm_medium=center_banner&utm_content=observability" class="button-banner button-brown-outline">Book a Demo</a>' +
                    '</div>' +
                    '<div class="col-lg-6 col-md-6 banner-img">' +
                        '<img src="/blog/assets/images/atatus-transparent-logo.svg" class="banner-logo" alt="atatus-logo" />' +
                        '<img src="/blog/assets/images/observability-monitoring.webp" class="product-img" alt="observability" />' +
                    '</div>' +
                '</div>' +
            '</div>',
        "container-cta-banner":
            '<div class="blog-review-wrapper bg-container-gradient">' +
                '<div class="row">' +
                    '<div class="col-lg-6 col-md-6">' +
                        '<h3>Keep Your Containerized Applications Healthy</h3>' +
                        '<p>Gain real-time visibility into container health, performance, and security with curated metrics. Get a unified, comprehensive view of container-based microservices.</p>' +
                        '<a href="https://www.atatus.com/signup?utm_source=blog&utm_medium=side_banner" class="button-banner button-leaf-green-bg margin-right-10">Sign up for free</a>' +
                        '<a href="https://www.atatus.com/request-demo?utm_source=blog&utm_medium=center_banner&utm_content=container" class="button-banner button-leaf-green-outline">Book a Demo</a>' +
                    '</div>' +
                    '<div class="col-lg-6 col-md-6 banner-img">' +
                        '<img src="/blog/assets/images/atatus-transparent-logo.svg" class="banner-logo" alt="atatus-logo" />' +
                        '<img src="/blog/assets/images/container-monitoring.webp" class="product-img" alt="container" />' +
                    '</div>' +
                '</div>' +
            '</div>',
        "opentelemetry-cta-banner":
            '<div class="blog-review-wrapper bg-opentelemetry-gradient">' +
                '<div class="row">' +
                    '<div class="col-lg-6 col-md-6">' +
                        '<h3>Unify Telemetry Across Your Stack</h3>' +
                        '<p>Use OpenTelemetry for standardized metrics, traces, and logs. Atatus integrates with OTel data, providing visibility and rapid issue resolution across your stack.</p>' +
                        '<a href="https://www.atatus.com/signup?utm_source=blog&utm_medium=side_banner" class="button-banner button-maroon-bg margin-right-10">Sign up for free</a>' +
                        '<a href="https://www.atatus.com/request-demo?utm_source=blog&utm_medium=center_banner&utm_content=opentelemetry" class="button-banner button-marron-outline">Book a Demo</a>' +
                    '</div>' +
                    '<div class="col-lg-6 col-md-6 banner-img">' +
                        '<img src="/blog/assets/images/atatus-transparent-logo.svg" class="banner-logo" alt="atatus-logo" />' +
                        '<img src="/blog/assets/images/otel-monitoring.webp" class="product-img" alt="opentelemetry" />' +
                    '</div>' +
                '</div>' +
            '</div>',
        "synthetic-cta-banner":
            '<div class="blog-review-wrapper bg-synthetic-gradient">' +
                '<div class="row">' +
                    '<div class="col-lg-6 col-md-6">' +
                        '<h3>Elevate User Experience with Synthetic Monitoring</h3>' +
                        '<p>Automate code-free API, browser, and mobile tests to proactively detect and simulate user flows, optimizing performance for reliable user experiences with Atatus.</p>' +
                        '<a href="https://www.atatus.com/signup?utm_source=blog&utm_medium=side_banner" class="button-banner button-pink-bg margin-right-10">Sign up for free</a>' +
                        '<a href="https://www.atatus.com/request-demo?utm_source=blog&utm_medium=center_banner&utm_content=synthetic" class="button-banner button-pink-outline">Book a Demo</a>' +
                    '</div>' +
                    '<div class="col-lg-6 col-md-6 banner-img">' +
                        '<img src="/blog/assets/images/atatus-transparent-logo.svg" class="banner-logo" alt="atatus-logo" />' +
                        '<img src="/blog/assets/images/synthetic-monitoring.webp" class="product-img" alt="synthetic" />' +
                    '</div>' +
                '</div>' +
            '</div>'
    };

    function fillBanners() {
        $.each(bannerTemplates, function(className, template) {
            $(`.${className}`).html(template);
        });
    }

    fillBanners();

});
